'use client'

import { FunctionComponent, useContext } from 'react'
import { useTranslation } from '../../context/ConfigContext'
import { ModalContext, ModalContextType } from '../../context/ModalContext'
import ModalContact from '../Modal/ModalContact'

const ButtonContact: FunctionComponent = () => {
  const { addModal } = useContext(ModalContext) as ModalContextType
  const t = useTranslation()

  return (
    <button
      type='button'
      className='contact-title'
      onClick={() => {
        const uuid = crypto.randomUUID()
        addModal({
          uuid,
          component: <ModalContact uuid={uuid} />,
        })
      }}>
      {t('cms-service-contact-text')}
    </button>
  )
}

export default ButtonContact
